<template>
  <Heading id="branchListHeading" tag="h2" size="md" align="center" class="text-charcoal-default mb-xl"
    >All MKM branches</Heading
  >

  <section
    aria-labelledby="branchListHeading"
    class="grid md:grid-cols-2 gap-x-md gap-y-xs max-w-[950px] mx-auto mb-3xl px-xs md:px-none"
  >
    <ul v-for="(group, index) in groupedBranches" :key="`${group}-${index}`">
      <li>
        <div class="border-b-sm border-grey-light px-xs py-2xs">
          <Text tag="h3" size="md" weight="bold" class="text-charcoal-default">{{ group.group }}</Text>
        </div>

        <ul>
          <li v-for="branch in group.children" :key="branch.id" class="px-xs py-[6px]">
            <NuxtLink :to="`/branches/${branch.slug}`" data-test-id="branchList" data-fs="branchList">
              <Text tag="span" size="md" weight="normal">
                {{ branch.name }}
              </Text>
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
const { allFetchedBranches } = useBranches();

const newBranches = allFetchedBranches.value;

const groupedBranches = computed(() => {
  if (!newBranches) return {};

  // Sort newBranches by city name
  const sortedBranches = [...newBranches].sort((a, b) => a.city.localeCompare(b.city));

  // Group branches by the first letter of the city
  return sortedBranches.reduce((groups: Record<string, { group: string; children: any[] }>, branch) => {
    const key = branch.city[0];

    if (!groups[key]) {
      groups[key] = {
        group: key,
        children: [],
      };
    }
    groups[key].children.push(branch);
    return groups;
  }, {});
});
</script>
